import CardsInsured from "@/components/header/cardsInsured";
export default {
  components: {
    CardsInsured
  }
};